import type { ReactNode } from "react";

const IconBadge = ({ children }: { children: ReactNode }) => (
  <div className="mx-auto flex size-14 items-center justify-center rounded-full border border-dark-primary-main/40 bg-dark-primary-main/10 text-dark-primary-main">
    {children}
  </div>
);

export default IconBadge;
